import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = "/api";

const formatDetail = (detail) => {
  if (detail == null) return "Something went wrong. Try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail?.msg || String(detail);
};

const inputCls =
  "w-full border border-[#1F1F1F] bg-[#050505] px-4 py-3.5 text-sm text-white placeholder-[#555555] outline-none transition-colors duration-300 focus:border-[#E11D2E]";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatDetail(err?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center justify-center gap-2.5">
          <span className="h-2.5 w-2.5 bg-[#E11D2E]" />
          <span className="font-display text-sm font-800 tracking-[0.22em] text-white">CYBER SMOKE</span>
          <span className="font-mono text-[10px] tracking-[0.3em] text-[#8A8A8A]">ADMIN</span>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="border border-[#1F1F1F] bg-[#0D0D0D] p-8">
          <label htmlFor="admin-email" className="mb-2 block font-mono text-[11px] uppercase tracking-[0.18em] text-[#8A8A8A]">Email</label>
          <input id="admin-email" data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="admin@cybersmokemedia.com" />
          <label htmlFor="admin-password" className="mb-2 mt-5 block font-mono text-[11px] uppercase tracking-[0.18em] text-[#8A8A8A]">Password</label>
          <input id="admin-password" data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
          {error && <p data-testid="admin-login-error" className="mt-4 font-mono text-xs text-[#E11D2E]">{error}</p>}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="mt-6 w-full bg-[#E11D2E] py-3.5 font-mono text-xs font-600 uppercase tracking-[0.14em] text-white transition-colors hover:bg-[#F13B47] disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
